import React, { useState } from 'react';
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";
import { SEO } from '../components/shared/SEO';

export const ContactoScreen = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({ stage: '', name: '', email: '', message: '' });
  const [isSending, setIsSending] = useState(false);

  const handleStage = (stage) => {
    setFormData({ ...formData, stage });
    setStep(2);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isSending) return;

    // Basic validation
    if (!formData.name || !formData.message) {
      Swal.fire("Faltan datos", "Por favor completa tu nombre y mensaje.", "warning");
      return;
    }

    setIsSending(true);

    // Prepare data for EmailJSSS
    // Appending stage to the message for context
    const templateParams = {
      user_name: formData.name,
      user_email: formData.email || "No especificado",
      user_asunto: `Consulta web - Etapa: ${formData.stage}`,
      user_mensaje: `[Etapa del Negocio: ${formData.stage}]\n\n${formData.message}`
    };

    emailjs.send(
      "service_i7r9uvb",
      "template_c8yzmtt",
      templateParams,
      "2p0oAOff099358Gyq"
    )
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        Swal.fire({
          title: "¡Mensaje Enviado!",
          text: "Gracias por contactarnos. Te responderemos a la brevedad.",
          icon: "success",
          confirmButtonColor: "#1A2B48"
        });
        setStep(1);
        setFormData({ stage: '', name: '', email: '', message: '' });
      })
      .catch((err) => {
        console.log('FAILED...', err);
        Swal.fire({
          title: "Error",
          text: "Hubo un problema al enviar el mensaje. Por favor intenta nuevamente o contáctanos por WhatsApp.",
          icon: "error",
          confirmButtonColor: "#1A2B48"
        });
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  return (
    <div className="section-padding container">
      <SEO
        title="Contacto y Asesoramiento Contable en Corrientes"
        description="Contáctenos para una asesoría contable e impositiva personalizada en Corrientes Capital. R&M Estudio Contable: atención presencial y digital."
        keywords="contacto contadores corrientes, estudio contable corrientes capital, asesoramiento contable corrientes telefono direccion"
        url="https://rymcontable.com.ar/contacto"
      />

      <div className="text-center" style={{ marginBottom: '3rem' }}>
        <h2>Inicie la Transformación de su Negocio</h2>
        <p>Complete el formulario interactivo para que podamos entender mejor sus necesidades.</p>
      </div>

      <div className="glass-card" style={{ maxWidth: '600px', margin: '0 auto', padding: '3rem', minHeight: '400px' }}>
        {step === 1 && (
          <div className="fade-in">
            <h3 className="text-center" style={{ marginBottom: '2rem' }}>¿En qué etapa se encuentra su negocio?</h3>
            <div className="stage-options" style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <button className="btn-stage" onClick={() => handleStage('Idea / Proyecto')}>
                TENGO UNA IDEA / PROYECTO
              </button>
              <button className="btn-stage" onClick={() => handleStage('En Marcha')}>
                NEGOCIO EN MARCHA (Monotributo/RI)
              </button>
              <button className="btn-stage" onClick={() => handleStage('Empresa Consolidada')}>
                EMPRESA CONSOLIDADA (PyME / SA / SRL)
              </button>
            </div>
          </div>
        )}

        {step === 2 && (
          <form className="fade-in" onSubmit={handleSubmit}>
            <div style={{ marginBottom: '1rem' }}>
              <span style={{ fontSize: '0.9rem', color: 'var(--color-accent)', fontWeight: 'bold' }}>Etapa seleccionada: {formData.stage}</span>
              <button type="button" onClick={() => setStep(1)} style={{ float: 'right', background: 'none', color: '#999', fontSize: '0.8rem' }}>Cambiar</button>
            </div>

            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>Nombre Completo *</label>
            <input
              type="text"
              required
              className="form-control"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            />

            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>Email (Opcional)</label>
            <input
              type="email"
              className="form-control"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            />

            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>¿Cómo podemos ayudarle? *</label>
            <textarea
              rows="4"
              required
              className="form-control"
              value={formData.message}
              onChange={(e) => setFormData({ ...formData, message: e.target.value })}
            ></textarea>

            <button type="submit" className="btn-primary" style={{ width: '100%', marginTop: '1rem' }} disabled={isSending}>
              {isSending ? 'Enviando...' : 'Enviar Consulta'}
            </button>
          </form>
        )}
      </div>

      {/* Custom Map Section Placeholder */}
      <div style={{ marginTop: '5rem' }}>
        <h3 className="text-center" style={{ marginBottom: '2rem' }}>Nuestra Ubicación</h3>
        <div style={{ width: '100%', height: '400px', background: '#eee', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999' }}>
          <iframe
            title="Mapa Corrientes"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d113426.69707252033!2d-58.8335011!3d-27.4692131!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94456ca6d24ec0c3%3A0x67605d2179e0a29!2sCorrientes%2C%20Corrientes%20Province!5e0!3m2!1sen!2sar!4v1689798765432!5m2!1sen!2sar"
            width="100%"
            height="100%"
            style={{ border: 0, borderRadius: '8px', filter: 'grayscale(0.8)' }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade">
          </iframe>
        </div>
      </div>
    </div>
  );
};
